module.exports = __webpack_public_path__ + "static/img/cloud_saas_acceleration_banner_bg.e67ac85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cloud_saas_acceleration_banner_bg.jpg
// module id = bNMp
// module chunks = 0